type AttributeOption = {
  id: string;
  label: string;
};

type GroupStoredAttribute = {
  schemaId?: string;
  name?: string;
  values?: string[] | null;
  schemaName?: string | null;
  displayValues?: string[] | null;
  options?: AttributeOption[] | null;
  schemaType?: string | null;
};

type AttributeSchemaResult = {
  _id: string;
  name?: string;
  __typename?: string;
  options?: AttributeOption[];
};

export const mergeGroupSettingAttribute = (
  stored: GroupStoredAttribute,
  schemaFromList?: AttributeSchemaResult | null,
  { isDefault = false }: { isDefault?: boolean } = {},
) => {
  const storedId = isDefault ? stored.name : stored.schemaId;

  return {
    ...stored,
    ...schemaFromList,
    _id: schemaFromList?._id || storedId,
    schemaId: !isDefault ? stored.schemaId : undefined,
    // Prefer the attribute schema label over stored keys / unresolved schemaName
    name: schemaFromList?.name || stored.schemaName || stored.name,
    options: schemaFromList?.options?.length
      ? schemaFromList.options
      : stored.options || [],
    __typename:
      schemaFromList?.__typename ||
      stored.schemaType ||
      'FreeTextAttributeSchema',
    values: stored.values ?? [],
    displayValues: stored.displayValues,
    isDefault,
  };
};

export const getContactAttributeLists = (
  attrs?:
    | {
        defaultAttributes?: unknown[] | null;
        customAttributes?: unknown[] | null;
      }
    | unknown[]
    | null,
): { defaultAttributes: any[]; customAttributes: any[] } => {
  if (!attrs) {
    return { defaultAttributes: [], customAttributes: [] };
  }
  if (Array.isArray(attrs)) {
    return {
      defaultAttributes: attrs.filter((item: { isDefault?: boolean }) => item?.isDefault),
      customAttributes: attrs.filter((item: { isDefault?: boolean }) => !item?.isDefault),
    };
  }
  return {
    defaultAttributes: attrs.defaultAttributes || [],
    customAttributes: attrs.customAttributes || [],
  };
};

export const contactAttributesAreSelected = (
  attrs?: Parameters<typeof getContactAttributeLists>[0],
): boolean => {
  const { defaultAttributes, customAttributes } = getContactAttributeLists(
    attrs,
  );
  return defaultAttributes.length > 0 || customAttributes.length > 0;
};

export const formatGroupAttributeValuesForDisplay = (attribute: {
  values?: string[] | null;
  displayValues?: string[] | null;
  options?: AttributeOption[];
}): string[] => {
  if (attribute.displayValues?.length) {
    return attribute.displayValues;
  }

  const values = attribute.values || [];
  if (!values.length || !attribute.options?.length) {
    return values;
  }

  return values.map(value => {
    const optionById = attribute.options?.find(option => option.id === value);
    if (optionById?.label) {
      return optionById.label;
    }

    const optionByLabel = attribute.options?.find(
      option => option.label === value,
    );
    return optionByLabel?.label || value;
  });
};
